<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FMEP">Everybody knows they are going to die, but no one really believes it.</p>
<p class="FMEPC"><span class="ePub-I">—Spalding Gray</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?173e2407